import React from 'react';
import { ProductBackgroundAuth } from '../../components/auth/ProductBackgroundAuth';
export function SignupPage() {
  const handleSignup = (data: any) => {
    console.log('Signup data:', data);
    // Handle signup logic here
    setTimeout(() => {
      window.location.href = '/';
    }, 1500);
  };
  return <ProductBackgroundAuth mode="signup" onSubmit={handleSignup} data-id="element-8007" />;
}